import React from 'react';
import classNames from 'classnames';

function OverviewLayoutTemplate ({ helpers, modelAttributes }) {

	const { Id } = modelAttributes;

	const {
		consultantPhoneNumber, hideViewMoodBoard, isCustomerService, showCallAndChat, showChat
	} = helpers;

	const regionViewMoodBoardClassName = classNames(hideViewMoodBoard && 'hidden');

	return (
		<>
			<div className="overviewHeader">
				<div id="regionCartTotalTop" />
				<div id="regionCartOptions" />
			</div>

			{isCustomerService && <div id="customerInfo" className="customerInfo" />}

			<div className="couponCodeError cartWarningMessage hidden" />
			<div className="removePromoCodeDiv hidden">
				<br />
				<button type="button" className="removePromoCode anchorLink" aria-label="remove coupon code">
					Remove Coupon Code
				</button>
			</div>

			<div id="regionInternationalMinimumOrderError" />

			<div id="regionResaleLicenseWarningMessage" />

			<div id="cartOverviewWarningMessagesContainer" />

			<div id="regionShippingOptionsChanged" />

			<div id="productItemsOrderSummary">
				<div id="productItemsContainer">
					<div id="productItems" />
					<div id="regionAddRecommendedBulbs" />
					<div className="overviewFooterContainer group">
						<div className="fl">
							<div className="promoCodeContainer group fl">
								<div className="promoCodeInfo fl">
									<div id="regionSelectedPromoCodeMessage" />

									<ul className="regionCartLinks pipeListFlex unstyledList">
										<li id="regionPromoCodeStatusMessage" />
										<li id="regionPromoCodeTermsAndConditionsLink" />
										<li id="regionAddPromoCode" className="regionAddPromoCode noPipe" />
										<li className={regionViewMoodBoardClassName} id="regionViewMoodBoard" />
										<li id="regionPrintCartLink" />
										<li id="regionEmailCartLink" />
									</ul>

									<div id="regionRemovePromoCode" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="orderSummaryContainer">
					<div className="orderSummaryBox">
						<h2 className="orderSummaryHead">Order Summary</h2>
						<div id="orderSummary" className="orderSummary" />
						<div id="regionPayPalLaterWidget" />
						<div className="cartCalloutButtons">
							<div className="buttonValidationTooltipContainer">
								<div id="regionCheckoutNowButtonBottom" />
								<div id="regionOrderTaxExemptCheckbox" />
								<div id="regionButtonValidationTooltipBottom" />
							</div>
							<div className="buttonValidationTooltipContainerPaypal">
								<div id="regionPaypalButtonBottom" className="checkoutErrorTooltip paypalContainer" />
								<div id="regionButtonValidationTooltipBottomPaypal" />
							</div>
						</div>
					</div>
					{showCallAndChat && (
						<div className="needHelp">
							<div className="calloutText">
								{'Call '}
								{consultantPhoneNumber}
								{showChat && <span id="cartChat1aContainer" />}
							</div>
						</div>
					)}
					<div className="tac">
						<span id="cartId" className="itemWithSep">
							Cart #
							{Id}
						</span>
					</div>
				</div>
			</div>

			<div id="priceChangedNotificationModalContent" className="hidden" />
		</>
	);

}

export default OverviewLayoutTemplate;
